<template>
  <div class="margin-bottom-s margin-top-xxl text-center">
    <p class="text-center margin-bottom-xs barcode-text grid-x cell align-center">
      <AtomicUiSkeleton height="20px" width="410px" />
    </p>
    <div class="grid-x cell align-center">
      <AtomicUiSkeleton height="100px" width="200px" class="margin-bottom-xs" />
    </div>
    <div class="grid-x cell align-center">
      <AtomicUiSkeleton height="20px" width="150px" class="margin-bottom-xxl" />
    </div>
  </div>
</template>

<script setup></script>
